import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

export function NewTabLink({ to, children }) {
  return (
    <Link rel="noopener noreferrer" target="_blank" to={to}>
      {children}
    </Link>
  );
}

NewTabLink.propTypes = {
  children: PropTypes.node,
  to: PropTypes.string.isRequired
};
